import { render, staticRenderFns } from "./_consent-collection-widgets.vue?vue&type=template&id=4f35ca9c"
import script from "./_consent-collection-widgets.vue?vue&type=script&lang=js"
export * from "./_consent-collection-widgets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports